<script>
import DispatchConfirmationStatus from "@/views/trips/components/DispatchConfirmationStatus.vue";
import DispatchConfirmationAction from "@/views/trips/view/components/DispatchConfirmationAction.vue";
import GoogleMapsMixin from "@/mixins/google-maps.mixin";
import StepperItem from "@/views/trips/components/StepperItem.vue";
import DistanceLine from "@/views/trips/components/DistanceLine.vue";
import RouteStopActions from "@/views/trips/components/RouteStopActions.vue";
import AlertMessage from "@/components/messages/AlertMessage.vue";
import RedispatchConfirmationDialog from "@/views/trips/components/dialogs/RedispatchConfirmationDialog.vue";
import { RouteStatus } from "@/constants/trip.js";
import { useDateTime } from "@/composables/index.js";
import { useAppStore } from "@/store/app.store.js";
import { mapState } from "pinia";

const { dateTZ } = useDateTime();

export default {
  name: "DeadheadStop",
  components: {
    RedispatchConfirmationDialog,
    AlertMessage,
    RouteStopActions,
    DistanceLine,
    StepperItem,
    DispatchConfirmationAction,
    DispatchConfirmationStatus,
  },
  mixins: [GoogleMapsMixin],
  props: {
    route: Object,
    trip: Object,
    undoable: Boolean,
  },
  emits: ["change"],
  data() {
    return {
      showRedispatchDialog: false,
    };
  },
  computed: {
    ...mapState(useAppStore, ["dispatcher"]),
    isRedispatchNotConfirmed() {
      return this.route.redispatch === "not-confirmed";
    },
    isCancelled() {
      return this.route.status === RouteStatus.cancelled;
    },
    deadheadClass() {
      if (this.isCancelled) {
        return "bg-red-lighten-5";
      }

      return "bg-grey-lighten-4";
    },
  },
  methods: {
    onChange() {
      this.$emit("change");
    },
    formatDate(date) {
      return this.dispatcher ? dateTZ(date, this.dispatcher.timezone) : "";
    },
  },
};
</script>

<template>
  <stepper-item
    :active="!route.dispatchConfirmed"
    :complete="route.dispatchConfirmed"
    :is-cancelled="isCancelled"
    :number="1"
    first
  >
    <div :class="deadheadClass" class="rounded pa-4 flex-1 mb-2">
      <div class="d-flex align-center justify-space-between">
        <div class="text-blue-grey-darken-1 font-size-12 font-weight-600">
          <v-icon class="mr-3" icon="mdi-truck-outline"></v-icon>
          Deadhead
        </div>
        <div class="d-flex align-center" data-qa="deadhead-dispatch-status">
          <dispatch-confirmation-status
            :is-confirmed="route.dispatchConfirmed"
            class="mr-4"
          ></dispatch-confirmation-status>
          <route-stop-actions
            v-if="undoable"
            :route="route"
            :stop="{}"
            :trip="trip"
            class="ml-3"
            @change="onChange"
          ></route-stop-actions>
        </div>
      </div>
      <div v-if="route.dispatchAddress" class="d-flex align-center mt-3">
        <div class="mr-2 text-grey-darken-3" data-qa="deadhead-start-location-route">{{ route.dispatchAddress }}</div>
        <a
          :href="getPlaceUrl({ lon: route.dispatchCoordinates.lon, lat: route.dispatchCoordinates.lat })"
          target="_blank"
        >
          <v-icon color="success" icon="mdi-map-marker-radius-outline" size="16"></v-icon>
        </a>
      </div>
      <div v-if="route.dispatchConfirmed" class="mt-2 text-grey-darken-1">
        {{ formatDate(route.dispatchTime) }}
      </div>
      <template v-if="isRedispatchNotConfirmed">
        <v-btn
          block
          class="text-uppercase font-weight-600 mt-4"
          color="primary"
          variant="flat"
          @click="showRedispatchDialog = true"
        >
          Confirm re-dispatch
        </v-btn>

        <redispatch-confirmation-dialog
          v-model="showRedispatchDialog"
          :route="route"
          :trip-id="trip.id"
          :truck="route.truck"
          class="mt-3"
        ></redispatch-confirmation-dialog>
      </template>

      <dispatch-confirmation-action v-else :route="route" :trip="trip" class="mt-3"></dispatch-confirmation-action>
      <alert-message v-if="isRedispatchNotConfirmed" class="mt-3"> Re-dispatch is not confirmed yet</alert-message>
    </div>
    <distance-line :value="route.emptyMiles"></distance-line>
  </stepper-item>
</template>

<style lang="scss" scoped></style>
